/* eslint-disable import/prefer-default-export */
/**
 * 관리 대상 타입에 따라 IP 표현 여부를 체크한다.
 * @/utils/tree의 isRequireIPObjType와 동기화해줘야한다.
 * @author Ju
 * @param  {String}  managetypeId 관리 구분 아아디
 * @param  {String}  objtypeId    장비 구분 아이디
 * @return {Boolean}              IP 표현 여부 (TRUE: 표현 / FALSE: 미표현)
 */
export function isRequiredShowIp(managetypeId, objtypeId) {
  if (managetypeId === 'VMS') {
    return objtypeId === 'VHO' || objtypeId === 'VVM';
  }
  return managetypeId !== 'SMS' && managetypeId !== 'E2E';
}



// WEBPACK FOOTER //
// ./src/utils/obj.js